// http://test-actcenter.jd.com/menu/list
/**
 * 整个环境分为两部分，一部分是线上，一部分是开发
 * 线上分为两部分，一部分是beta，一部分是production
 * 线下分为production、beta、localMock和easyMock
 */
import envBeta from './env.beta';
import envProd from './env.prod';
import envRelease from './env.release';
import envDev from './env.dev';
import { ENV } from './types';

function getValueByEnv<T = ENV>(allEnvData: Record<'envDev' | 'envBeta' | 'envRelease' | 'envProd', T>) {
  // NODE_ENV 只有两个值一个是production一个是development
  // 本地开发
  if (process.env.NODE_ENV === 'development') return allEnvData.envDev || allEnvData.envProd;

  // 打包发版(生产 | 预发)
  // 接口环境
  // 生产环境
  if (process.env.API_ENV === 'production') return allEnvData.envProd || allEnvData.envProd;

  // 预发 / 准线上环境
  if (process.env.API_ENV === 'release') return allEnvData.envRelease || allEnvData.envProd;

  // 测试环境
  if (process.env.API_ENV === 'beta') return allEnvData.envBeta || allEnvData.envProd;

  return allEnvData.envProd;
}

let env: ENV = getValueByEnv({ envDev, envProd, envRelease, envBeta });

const HD_API_DOMAIN = env.HD_API_DOMAIN;

function addDomain(url: string, domain = HD_API_DOMAIN) {
  if (typeof url !== 'string') return url;
  url = url.trim();
  if (url.indexOf('http') === 0 || url.indexOf('//') === 0) return url;
  return domain + url;
}

function getDomain() {
  return HD_API_DOMAIN;
}

const HD_API_TOOL_DOMAIN = env.HD_API_TOOL_DOMAIN;

function addToolDomain(url: string) {
  if (typeof url !== 'string') return url;
  url = url.trim();
  if (url.indexOf('http') === 0 || url.indexOf('//') === 0) return url;
  return HD_API_TOOL_DOMAIN + url;
}

function getToolDomain() {
  return HD_API_TOOL_DOMAIN;
}
export { getDomain, getToolDomain, addDomain, addToolDomain, HD_API_DOMAIN, HD_API_TOOL_DOMAIN, env, getValueByEnv };

export default env;
